/* eslint-disable
    guard-for-in,
    no-restricted-syntax,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
angular.module('unergie.main')
.controller('featuresCtrl', ($scope, $state, $uibModal, DataAccessFeatures, ErrorCatcher) => {
    $scope.isActive = (state) => $state.is(state)

    $scope.editToggles = {}
    let backupData = {}


    const reset = function () {
        $scope.features = angular.copy(backupData)
        return $scope.features.forEach((d) =>
            (() => {
                const result = []
                for (const k in d.features) {
                    // const v = d.features[k]
                    result.push($scope.editToggles[d.id + k] = true)
                }
                return result
            })(),
        )
    }

    const refresh = () =>
        DataAccessFeatures.getFeatures().$promise.then((data) => {
            backupData = data
            return reset()
        }).catch(ErrorCatcher)

    $scope.refresh = refresh
    refresh()

    $scope.toggle = function (id, feat) {
        $scope.editToggles[id + feat] = !$scope.editToggles[id + feat]
        if ($scope.editToggles[id + feat]) {
            return reset()
        }
    }

    $scope.saveFeature = function (feature, feat, value) {
        if (!$scope.editToggles[feature.id + feat]) {
            feature.features[feat] = value
            return DataAccessFeatures.putFeature({ id: feature.id }, feature).$promise.then((data) => refresh()).catch(ErrorCatcher)
        }
    }

    $scope.deleteFeatureGroup = (featureGroup) =>
        DataAccessFeatures.delFeature({ id: featureGroup.id }).$promise.then((data) => refresh()).catch(ErrorCatcher)


    $scope.deleteFeature = function (group, feature) {
        delete group.features[feature]
        return DataAccessFeatures.putFeature({ id: group.id }, group).$promise.then((data) => refresh()).catch(ErrorCatcher)
    }

    $scope.openAddFeature = function (featureGroup) {
        const modalInstance = $uibModal.open({
            animation: true,
            templateUrl: '/addFeature',
            controller: 'addFeatureCtrl',
            resolve: {
                featureGroup() {
                    return featureGroup
                },
            },
        })
        return modalInstance.result.then((feature) => {
            featureGroup.features[feature.featureName] = feature.value
            return DataAccessFeatures.putFeature({ id: featureGroup.id }, featureGroup).$promise.then((data) => refresh()).catch(ErrorCatcher)
        })
    }

    $scope.openAddFeatureGroup = function () {
        const modalInstance = $uibModal.open({
            animation: true,
            templateUrl: '/addFeatureGroup',
            controller: 'addFeatureGroupCtrl',
        })
        return modalInstance.result.then((featureGroupName) => {
            const featureGroup = { id: featureGroupName, features: {} }
            return DataAccessFeatures.postFeature(featureGroup).$promise.then((data) => refresh()).catch(ErrorCatcher)
        })
    }
}).controller('addFeatureCtrl', ($scope, $uibModalInstance, featureGroup) => {
    $scope.featureGroup = featureGroup
    $scope.feature = { type: 'string' }

    $scope.ok = () => $uibModalInstance.close($scope.feature)

    $scope.cancel = () => $uibModalInstance.dismiss('cancel')
}).controller('addFeatureGroupCtrl', ($scope, $uibModalInstance) => {
    $scope.featureGroup = null
    $scope.ok = () => $uibModalInstance.close($scope.featureGroup)

    $scope.cancel = () => $uibModalInstance.dismiss('cancel')
})
